import { Environment } from 'react-relay';
// import { MutationConfig } from 'relay-runtime';
// import { UserLogoutMutation as UserLogoutMutationType } from '../../../mutationsModern/User/__generated__/UserLogoutMutation.graphql';
import UserLogoutMutation from '../../../mutationsModern/User/UserLogoutMutation';
import { resetSegment } from '../../../utils/tracking';

const noop = () => {};

export default function handleLogout(
  isLoggingOut: (bool: boolean) => void = () => {},
) {
  return (
    environment: Environment,
    onCompleted: (...args: any[]) => void = noop,
  ) => {
    isLoggingOut(true);
    return UserLogoutMutation.commit({
      environment,
      onCompleted: (...args) => {
        onCompleted(...args);
        console.log('logout success', args);
        resetSegment();
        window.location.reload();
        return true;
      },
      onError: errors => console.error('logout failed', errors[0]),
    });
  };
}
